// Default container styling
export const containerStyle = {
  width: "100%",
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  boxSizing: "inherit"
};
